/* tslint:disable */
/* eslint-disable */
export enum EventDeliveryOrderByEnum {
  Id = 'Id',
  CreatedUtc = 'CreatedUtc',
  Status = 'Status'
}
